(function () {
  if (window.pbSwatchesReady) return;
  window.pbSwatchesReady = true;

  function applySwatch(btn) {
    var card = btn.closest('.card-wrapper');
    if (!card) return;
    card.querySelectorAll('.card__media img').forEach(function (img) {
      img.removeAttribute('loading');
      img.srcset = btn.dataset.srcset;
      img.src = btn.dataset.src;
    });
    card.querySelectorAll('a.full-unstyled-link[href]').forEach(function (link) {
      link.href = btn.dataset.url;
    });
    btn.parentElement.querySelectorAll('.pb-sw__dot').forEach(function (dot) {
      dot.setAttribute('aria-pressed', dot === btn ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.pb-sw__dot');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    applySwatch(btn);
  });

  document.addEventListener('mouseover', function (event) {
    var btn = event.target.closest && event.target.closest('.pb-sw__dot');
    if (btn) applySwatch(btn);
  });
})();
